import React from "react";
import playStoreIcon from "../../assets/google-play-badge.png";
import appStoreIcon from "../../assets/app-store-badge.png";
import { Link } from "react-router-dom";
import { playStoreUrl } from "constants";
import { appStoreUrl } from "constants";
import { mavenceryPrivacyPolicy } from "constants";
import { useSelector } from "react-redux";

const Footer = () => {
  const { selectedStore } = useSelector((store) => store.selectedStore);
  return (
    <>
      {selectedStore && selectedStore ? (
        <div className="bottom-0 flex flex-col items-center justify-center w-full py-0 text-center text-black border border-t-2 z-1000   footer">
          <div className="flex items-center h-10 gap-3 ">
            <Link to={playStoreUrl} className="w-20">
              <img src={playStoreIcon} alt="playstore" />
            </Link>
            <Link to={appStoreUrl} className="w-20">
              <img src={appStoreIcon} alt="appstore" />
            </Link>
          </div>
          <div className="flex flex-row items-center justify-center cursor-pointer lg:flex-row md:flex-row">
            <p className="italic md:text-xs lg:text-xs text-xxs">
              Copyright &copy; <span>{new Date().getFullYear()}</span>
              <span className="ml-1 font-bold">
                {selectedStore && selectedStore.isWhiteLabel
                  ? selectedStore.name
                  : "Mavencery"}
              </span>
              . All rights reserverd.
            </p>
            <Link to={mavenceryPrivacyPolicy}>
              <p className="ml-2 font-bold md:text-xs lg:text-xs text-xxs ">
                Privacy Policy
              </p>
            </Link>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default Footer;
